import { Module, VuexModule, Action } from 'vuex-module-decorators';

import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import { BASE_URL, FETCH_LOG_TRACKING, M_POST, M_GET } from '@/utils/api';

import type { IfetchTrackingLogs } from '@/interface/TrackingLogs';

@Module({ name: 'trackingLogs' })
export default class TrackingLogs extends VuexModule {
  @Action
  async FetchTrackingLogs(params: IfetchTrackingLogs) {
    try {
      const { data } = await axios({
        url: BASE_URL + FETCH_LOG_TRACKING,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch tracking logs failed');
      return data;
    } catch (err) {
      throw toError(err, 'Fetch tracking logs failed');
    }
  }

  @Action
  async FetchTrackingLogsDetail(docId: string) {
    try {
      const { data } = await axios({
        url: `${BASE_URL}${FETCH_LOG_TRACKING}/${docId}`,
        method: M_GET
      });

      assertOk(data, 'Fetch tracking log detail failed');
      return data;
    } catch (err) {
      throw toError(err, 'Fetch tracking log detail failed');
    }
  }
}
